import InputHandler from "../../Tools/InputHandler";
import React, { useEffect, useState } from "react";
import Button from "../../../UI/Buttons/Button";
import { useTheme } from "../../../UI/Theme/ThemeContext";
import { FaGraduationCap } from "react-icons/fa";
import { StepsContainerStyled } from "../../../../styled/Resume";

const BasicInfo = (props) => {
  const {
    setStep,
    setStepData,
    basicInfo,
    handleInputChange,
    handleJobConnectType,
    jobConnectType,
    jobTypesArray,
    additionalInfo,
    basicLinkInfo,
    basicHandleAddLinks,
    basicHandleDeleteLinks,
    basicHandleLinkChange,
    basicInfoForward,
  } = props;

  const [disableFields, setDisableFields] = useState(false);
  const { themeName } = useTheme();

  useEffect(() => {
    // Validation: check if required fields are filled
    const requiredFields = [
      basicInfo.firstName,
      basicInfo.lastName,
      basicInfo.email,
      basicInfo.mobile,
      basicInfo.jobPosition,
      basicInfo.country,
      basicInfo.city,
      jobConnectType,
    ];

    const isValid = requiredFields.every(
      (field) => field && field.trim() !== ""
    );
    setDisableFields(!isValid);

    // Sync BasicInfo into stepData on every change
    setStepData((prev) => ({
      ...prev,
      basicInfo: {
        ...basicInfo,
        jobConnectType,
        additionalInfo,
      },
    }));
  }, [basicInfo, jobConnectType, additionalInfo, setStepData]);

  const handleClick = (e) => {
    if (e) e.preventDefault();
    basicInfoForward("forward");
    if (!disableFields) {
      setStep(2);
    }
  };

  return (
    <StepsContainerStyled theme={themeName}>
      <h2>Basic Information</h2>
      <div className="basic">
        <InputHandler
          type="text"
          id="basicInfo.firstName"
          name="firstName"
          value={basicInfo.firstName}
          label="First Name"
          required
          onChange={handleInputChange("firstName")}
        />
        <InputHandler
          type="text"
          id="basicInfo.lastName"
          name="lastName"
          value={basicInfo.lastName}
          label="Last Name"
          required
          onChange={handleInputChange("lastName")}
        />
        <InputHandler
          type="email"
          id="basicInfo.email"
          name="email"
          value={basicInfo.email}
          label="Email"
          required
          onChange={handleInputChange("email")}
        />
        <InputHandler
          type="mobile"
          id="basicInfo.mobile"
          name="mobile"
          value={basicInfo.mobile}
          label="Mobile"
          required
          onChange={handleInputChange("mobile")}
        />
        <InputHandler
          type="text"
          label="Job Position"
          id="basicInfo.jobPosition"
          name="jobPosition"
          value={basicInfo.jobPosition}
          onChange={handleInputChange("jobPosition")}
        />
        <InputHandler
          type="select"
          label="Type of Connection"
          id="jobConnectType"
          name="jobConnectType"
          value={jobConnectType}
          list={jobTypesArray}
          onChange={handleJobConnectType}
        />
        <InputHandler
          type="select"
          label="Country"
          id="basicInfo.country"
          name="country"
          value={basicInfo.country}
          onChange={handleInputChange("country")}
          inputType="country-select"
        />
        <InputHandler
          type="select"
          label="State"
          id="basicInfo.city"
          country={basicInfo.country}
          name="city"
          value={basicInfo.city}
          onChange={handleInputChange("city")}
          inputType="state-select"
        />
        {basicLinkInfo.map((info, index) => (
          <InputHandler
            key={info.id || index}
            label="[Optional] Add a link e.g Linkedin, Github or your website."
            id={`link-${index}`}
            value={info}
            type="links"
            required={false}
            onChange={(event) => basicHandleLinkChange(event, index)}
            handleDelete={basicHandleDeleteLinks}
            handleAdd={basicHandleAddLinks}
          />
        ))}
      </div>
      <div className="btn">
        <Button
          primary
          width="100%"
          clickHandle={handleClick}
          disabled={disableFields}
        >
          Education
          <FaGraduationCap />
        </Button>
      </div>
    </StepsContainerStyled>
  );
};

export default BasicInfo;